const tabValues = Object.freeze({
  myDashboard: 'my-dashboard',
  myTasks: 'my-tasks',
  myStudents: 'my-students',
  submissions: 'submissions',
  messageBoard: 'message-board'
});

export default tabValues
